var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Users")]),_c('ListFirestore',{attrs:{"item-name":"User","get-collection":_vm.getAccountUsers,"order-list":_vm.orderList},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var user = ref.item;
return [_c('AccountUser',{attrs:{"user":user}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }